var _path, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 59C46.0163 59 59 46.0163 59 30C59 13.9837 46.0163 1 30 1C13.9837 1 1 13.9837 1 30C1 46.0163 13.9837 59 30 59Z",
    stroke: "white",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 29,
    height: 39,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 39,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#FFAD43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#FFAD43"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#FFAD43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#FFAD43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.98fcf7202a58ea3477ac27710f07e4c4.svg";
export { ForwardRef as ReactComponent };